module.exports = __webpack_public_path__ + "img/TX2FCD.png";